import {Component, OnInit} from '@angular/core';
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-frontend-loading',
  standalone: true,
  templateUrl: './frontend-loading.component.html',
  imports: [
    MatProgressSpinner
  ],
  styleUrls: ['./frontend-loading.component.scss']
})
export class FrontendLoadingComponent implements OnInit {
  constructor() {
  }

  ngOnInit(): void {
  }
}
